import { Button, message } from 'antd';
import { FullScreenModal } from 'components/Signature/styles';
import { download } from 'helper/fileUtils';
import { useState } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';
import { convertUrlToBlob } from 'utils/common';

export const Container = styled('div')`
  padding: 0;
  padding-top: 1rem;
  height: 100%;
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  height: 100%;
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  gap: 8px;
  margin-left: auto;
`;

function fileToBlob(file: File): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      if (reader.result) {
        resolve(new Blob([reader.result], { type: 'application/pdf' }));
      } else {
        reject(new Error('File reading failed'));
      }
    };

    reader.onerror = () => {
      reject(new Error('File reading failed'));
    };

    reader.readAsArrayBuffer(file);
  });
}

interface ModalViewPDFSignExportProps {
  open: boolean;
  file: File;
  onClose: () => void;
}

function ModalViewPDFSignExport({ open, file, onClose }: ModalViewPDFSignExportProps): JSX.Element {
  const [previewUrl, setPreviewUrl] = useState('');
  const [previewBlob, setPreviewBlob] = useState<Blob | null>(null);

  const [previewSignedFileUrl, setPreviewSignedFileUrl] = useState<string>('');

  useEffect(() => {
    (async () => {
      try {
        const pdfBlob = await fileToBlob(file);
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPreviewUrl(pdfUrl);
        setPreviewBlob(pdfBlob);
      } catch (error) {
        setPreviewUrl('');
      }
    })();
  }, [file]);

  const handleDownload = async () => {
    try {
      const blob = await (async () => {
        if (previewSignedFileUrl) {
          return await convertUrlToBlob(previewSignedFileUrl);
        }
        return previewBlob;
      })();

      if (blob) {
        download(blob, file.name);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
      message.error('Lỗi khi xuất file pdf');
    }
  };

  return (
    <>
      <FullScreenModal
        visible={open}
        onCancel={onClose}
        footer={
          <ButtonWrapper>
            <Button onClick={onClose}>Đóng</Button>
            <Button type="primary" onClick={handleDownload}>
              Xuất file pdf
            </Button>
          </ButtonWrapper>
        }>
        <Container>
          <iframe
            src={previewSignedFileUrl || previewUrl}
            allowFullScreen
            width="100%"
            height="100%"
            title="pdf-document"></iframe>
        </Container>
      </FullScreenModal>

      {/* {openSign && (
        <BCYSignApproved
          signFileUrl={signUrl}
          onClose={() => setOpenSign(false)}
          onSuccess={(signedUrl, previewSignedFileUrl) =>
            handleUpdate(signedUrl, previewSignedFileUrl)
          }
        />
      )} */}
    </>
  );
}

export default ModalViewPDFSignExport;
